import { useEffect, useMemo, useState } from "react";
import useAuthUser from "../../auth/hooks/useAuthUser";
import {
  fetchTodayFileStats,
  fetchTodayOperatorFileStats,
  fetchTodayFileFailures,
} from "../services/home.api";

export function useHomeData() {
  const { loading: authLoading, user } = useAuthUser();
  const canFetch = useMemo(() => !authLoading && !!user, [authLoading, user]);

  const [fileStats, setFileStats] = useState(null);
  const [operatorStats, setOperatorStats] = useState(null);
  const [fileFailures, setFileFailures] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const ac = new AbortController();

    if (!canFetch) {
      setLoading(true);
      return () => ac.abort();
    }

    (async () => {
      try {
        setLoading(true);
        const [fs, ops, fails] = await Promise.all([
          fetchTodayFileStats(ac.signal),
          fetchTodayOperatorFileStats(ac.signal),
          fetchTodayFileFailures(ac.signal),
        ]);
        setFileStats(fs ?? null);
        setOperatorStats(ops ?? null);
        setFileFailures(Array.isArray(fails) ? fails : []);
      } catch (e) {
        if (e?.name === "AbortError") return; // expected on unmount/redirect
        console.error("useHomeData:", e);
        setFileStats(null);
        setOperatorStats(null);
        setFileFailures([]);
      } finally {
        setLoading(false);
      }
    })();

    return () => ac.abort();
  }, [canFetch]);

  return { fileStats, operatorStats, fileFailures, loading };
}
